
import { CotHttp, UrlDataEnum } from "../http-communication/cot-http.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { CustomerName } from "../services/common-utility.service";
import { Injectable } from "@angular/core";

// LogService
@Injectable()
export class LogService {

    constructor(private cotHttp: CotHttp, private http: HttpClient) {
    }

    log(data: LogEntry): Observable<any> {
        return this.http.post(this.cotHttp.getConfiguredUrl(UrlDataEnum.LogUrl) + '/AddLog', data);
        //return this.cotHttp.post(this.cotHttp.getConfiguredUrl(UrlDataEnum.LogUrl) + '/AddLog', data); // note: this might create infinite loop
    }

    clear(appId: number): Observable<any> {
        return this.http.get(this.cotHttp.getConfiguredUrl(UrlDataEnum.LogUrl) + '/ClearLog?appId=' + appId);
    }
}

function buildLogString(logEntry: LogEntry): string {
    let ret: string = "";
    ret += "Customer: " + CustomerName[logEntry.Customer] + "\r\n";
    ret += "Entry Date: " + logEntry.EntryDate + "\r\n";
    ret += "Type: " + LogLevel[logEntry.Level] + "\r\n";
    ret += " - Message: " + logEntry.Message + "\r\n";
    if (logEntry.ExtraInfo && logEntry.ExtraInfo.length > 0) {
        ret += " - Extra Info: " + formatParams(logEntry.ExtraInfo);
    }
    return ret;
}

function formatParams(params: any[]): string {
    let ret: string = params.join(",");
    if (params.some(p => typeof p == "object")) {
        ret = "";
        for (let item of params) {
            ret += JSON.stringify(item) + ",";
        }
        if (ret.endsWith(","))
            ret = ret.slice(0, ret.length - 1);
    }
    return ret;
}

// LogLevel
export enum LogLevel {
    All = 0,
    Debug = 1,
    Info = 2,
    Warn = 3,
    Error = 4,
    Fatal = 5,
    Off = 6
}

// LogEntry
export class LogEntry {
    public EntryDate: Date = new Date();
    public AppId: number = 0;
    public Level: LogLevel = LogLevel.Debug;
    public Message: string = "";
    public ExtraInfo: any[] = [];
    public Customer: CustomerName = CustomerName.DEFAULT;

    public LogEntry() {
        this.EntryDate = new Date();
        this.Level = LogLevel.Debug;
        this.Customer = CustomerName.DEFAULT;
    }
}



// WEBPACK FOOTER //
// ./src/app/http-communication/log-service.ts